import produce from "immer"
import { PathItem, PathItemFragmentDoc } from "../api/generated"
import { getApolloClient } from "../pathwright/PathwrightClient"

type PathItemFragment = {
  fragment: typeof PathItemFragmentDoc
  fragmentName: string
  id: string
}

export const updateCachedPathItemBlocks = (
  item: PathItem,
  blocks: PathItem["blocks"],
  content_id = 0
) => {
  const client = getApolloClient(window.school.id)

  const fragment = {
    fragment: PathItemFragmentDoc,
    fragmentName: "PathItem",
    id: `PathItem:${item.id}`
  } as PathItemFragment

  const fragmentData = client.readFragment(fragment)
  const nextFragmentData = produce(fragmentData, (draft: PathItem) => {
    if (!draft.blocks) {
      draft.blocks = {
        content_last_modified: null,
        last_published: null
      }
    }

    if (blocks?.content_last_modified) {
      draft.blocks.content_last_modified = blocks.content_last_modified
    }
    if (blocks?.last_published) {
      draft.blocks.last_published = blocks.last_published
    }

    if (content_id) {
      draft.content_id = content_id
    }
  })
  client.writeFragment({
    ...fragment,
    data: nextFragmentData
  })
}
